// @ts-nocheck
import { Switch, Route, Redirect } from "wouter";
import { Toaster } from "./components/ui/toaster";
import { TooltipProvider } from "./components/ui/tooltip";
import { AppLayout } from "./components/layout/AppLayout";
import { AiBotProvider } from "./lib/ai-bot-context";
import { Dashboard } from "./pages/Dashboard";
import { Devices } from "./pages/Devices";
import { Contacts } from "./pages/Contacts";
import { Templates } from "./pages/Templates";
import { Campaigns } from "./pages/Campaigns";
import { CampaignDetail } from "./pages/CampaignDetail";
import { Messages } from "./pages/Messages";
import { SingleSend } from "./pages/SingleSend";
import { Chatbot } from "./pages/Chatbot";
import { ScheduledMessages } from "./pages/ScheduledMessages";
import { MyApps } from "./pages/MyApps";
import { Webhooks } from "./pages/Webhooks";
import { Subscription } from "./pages/Subscription";
import { Support } from "./pages/Support";
import { Profile } from "./pages/Profile";
import { AuthKey } from "./pages/AuthKey";
import { AiBot } from "./pages/AiBot";
import { DeviceQR } from "./pages/DeviceQR";
import NotFound from "./pages/not-found";

function Router() {
  return (
    <AppLayout>
      <Switch>
        <Route path="/">
          <Redirect to="/dashboard" />
        </Route>
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/devices" component={Devices} />
        <Route path="/devices/:id/qr" component={DeviceQR} />
        <Route path="/contacts" component={Contacts} />
        <Route path="/templates" component={Templates} />
        <Route path="/single-send" component={SingleSend} />
        <Route path="/chatbot" component={Chatbot} />
        <Route path="/my-apps" component={MyApps} />
        <Route path="/campaigns/:id" component={CampaignDetail} />
        <Route path="/campaigns" component={Campaigns} />
        <Route path="/scheduled" component={ScheduledMessages} />
        <Route path="/messages" component={Messages} />
        <Route path="/webhooks" component={Webhooks} />
        <Route path="/subscription" component={Subscription} />
        <Route path="/support" component={Support} />
        <Route path="/profile" component={Profile} />
        <Route path="/auth-key" component={AuthKey} />
        <Route path="/ai-bot" component={AiBot} />
        <Route component={NotFound} />
      </Switch>
    </AppLayout>
  );
}

function App() {
  // Router / QueryClient / LangProvider are provided by the parent
  // wrapper (FlowUpPage.tsx) so we just render the routes + the
  // app-local providers (Tooltip + AiBot + Toaster).
  return (
    <TooltipProvider>
      <AiBotProvider>
        <Router />
      </AiBotProvider>
      <Toaster />
    </TooltipProvider>
  );
}

export default App;
